import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { getContrastingColor } from 'embed/utils'
import Spinner from '../LoadingIndicator/Spinner'

const styles = require('./styles')

export interface Props {
  children?: React.ReactNode
  fullWidth?: boolean
  isValid: boolean
  loading?: boolean
  onSubmit: () => void
}

const ApplicationSubmitButton: React.SFC<Props> = (props) => (
  <ThemeConsumer>
    {({ borderRadiusSmall, colorTextPrimary, ctaStyles }) => (
      <div className={classnames(styles.formSubmit, { [styles.fullWidth]: props.fullWidth })}>
        <button
          className={classnames(
            styles.button,
            css`
              color: ${getContrastingColor(ctaStyles?.backgroundColor, { black: colorTextPrimary })};
              border-radius: ${borderRadiusSmall};
            `,
            { [styles.disabled]: !props.isValid && !props.loading },
            { [styles.stepByStepButton]: props.fullWidth },
          )}
          style={ctaStyles}
          disabled={!props.isValid && !props.loading}
          id="applicationSubmitButton"
          onClick={props.onSubmit}
        >
          {props.children || 'Get my offers'}
          {props.loading && (
            <div className={styles.spinnerContainer}>
              <Spinner className={styles.spinner} />
            </div>
          )}
        </button>
      </div>
    )}
  </ThemeConsumer>
)

export default ApplicationSubmitButton
